import React, { useState } from 'react';
import {
    Container, Grid, TextField, Checkbox, FormControlLabel,
    Button, Typography, Box, FormControl , Avatar
} from '@mui/material';
import {  useLocation , useNavigate} from 'react-router-dom';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import { toast } from 'react-toastify';
import { submitMedicalForm } from '../api'; 
import { notifySuccess, notifyError } from '../Notification';
import ThankYouModal from '../layout/ThankyouModal';

const MedicalForm = ({ onSubmit }) => {
    const [isModalVisible, setModalVisible] = useState(false);
    const closeModal = () => {
        setModalVisible(false);  
      };
    const location = useLocation();
    const navigate = useNavigate();
  const child = location.state?.child;
    const [signatureImage, setSignatureImage] = useState(null);
    const [signatureImageFile, setSignatureImageFile] = useState(null);
    const [formData, setFormData] = useState({
        regularDoctor: '',
        regularDoctorCell: '',
        regularHospital: '',
        physicianAddress: '',
        susceptibleConditions: {
            asthma: false,
            rash: false,
            chills: false,
            headache: false,
            colds: false,
            fever: false,
            noseBleeds: false,
            throatInfections: false,
            convulsions: false,
            earInfections: false,
            other: '',
        },
        allergies: {
            food: '',
            drug: '',
            other: '',
        },
        dietaryRestrictions: '',
        visualProblems: '',
        auralProblems: '',
        physicalDisability: '',
        healthProblems: '',
        additionalInfo: '',
        height: '',
        weight: '',
        bloodGroup: '',
        vision: '',
        hearing: '',
        skin: '',
        hair: '',
        limitingConditions: '',
        additionalFindings: '',
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const [section, field] = name.split('.');
        if (section === 'susceptibleConditions' || section === 'allergies') {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [section]: {
                    ...prevFormData[section],
                    [field]: type === 'checkbox' ? checked : value,
                },
            }));
        } else {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
            }));
        }
    };

    const handleSignatureFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.size <= 2 * 1024 * 1024) {
            setSignatureImage(URL.createObjectURL(file));
            setSignatureImageFile(file);
        } else {
            toast.error('File size should be 2MB or less');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formDataToSubmit = new FormData();
        formDataToSubmit.append('student_id', child.id); 
        formDataToSubmit.append('signatureImageFile', signatureImageFile);
        Object.keys(formData).forEach(key => {
            if (typeof formData[key] === 'object') {
                formDataToSubmit.append(key, JSON.stringify(formData[key]));
            } else {
                formDataToSubmit.append(key, formData[key]);
            }
        });

        try {
            await submitMedicalForm(formDataToSubmit);
            notifySuccess("Form submitted successfully!");
            setModalVisible(true);
        } catch (error) {
            notifyError("Form submition failed !");
            // Error handling is already done in the API function
        }
    };

    return (
        <Container sx={{ p: 4, backgroundColor: 'white', borderRadius: '8px', width: '90%', maxWidth: '800px', margin: '0px auto' }}>
            <Typography variant="h5" gutterBottom>
                Medical Form (to be completed by Parents)
            </Typography>
            <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            label="Child's Regular Doctor"
                            name="regularDoctor"
                            value={formData.regularDoctor}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            label="Cell"
                            name="regularDoctorCell"
                            value={formData.regularDoctorCell}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            label="Regular Hospital Used"
                            name="regularHospital"
                            value={formData.regularHospital}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Hospital Address"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            multiline
                            rows={4}
                            name="physicianAddress"
                            value={formData.physicianAddress}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h6" gutterBottom>
                            Susceptible Conditions
                        </Typography>
                        <Grid container spacing={2}>
                            {Object.keys(formData.susceptibleConditions).map((condition) => (
                                condition !== 'other' ? (
                                    <Grid item xs={12} sm={6} md={4} key={condition}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={formData.susceptibleConditions[condition]}
                                                    onChange={handleChange}
                                                    name={`susceptibleConditions.${condition}`}
                                                />
                                            }
                                            label={condition.charAt(0).toUpperCase() + condition.slice(1)}
                                        />
                                    </Grid>
                                ) : (
                                    <Grid item xs={12} key={condition}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            label="Other"
                                            name="susceptibleConditions.other"
                                            value={formData.susceptibleConditions.other}
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                )
                            ))}
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            label="Food Allergy"
                            name="allergies.food"
                            value={formData.allergies.food}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            label="Drug Allergy"
                            name="allergies.drug"
                            value={formData.allergies.drug}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            label="Other Allergy"
                            name="allergies.other"
                            value={formData.allergies.other}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            label="Dietary Restrictions"
                            name="dietaryRestrictions"
                            value={formData.dietaryRestrictions}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            label="Visual Problems"
                            name="visualProblems"
                            value={formData.visualProblems}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            label="Aural Problems"
                            name="auralProblems"
                            value={formData.auralProblems}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            label="Physical Disability"
                            name="physicalDisability"
                            value={formData.physicalDisability}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            label="Health Problems that Require Special Attention"
                            name="healthProblems"
                            value={formData.healthProblems}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} mb="10px">
                        <TextField
                            variant="outlined"
                            fullWidth
                            label="Additional Information"
                            name="additionalInfo"
                            value={formData.additionalInfo}
                            onChange={handleChange}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="h5" gutterBottom>
                            Medical Form (to be completed by Family physician)
                        </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            variant="outlined"
                            required
                            fullWidth
                            label="Height"
                            name="height"
                            value={formData.height}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            variant="outlined"
                            required
                            fullWidth
                            label="Weight"
                            name="weight"
                            value={formData.weight}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            variant="outlined"
                            required
                            fullWidth
                            label="Blood Group"
                            name="bloodGroup"
                            value={formData.bloodGroup}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            variant="outlined"
                            required
                            fullWidth
                            label="Vision"
                            name="vision"
                            value={formData.vision}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            variant="outlined"
                            required
                            fullWidth
                            label="Hearing"
                            name="hearing"
                            value={formData.hearing}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            variant="outlined"
                            required
                            fullWidth
                            label="Skin"
                            name="skin"
                            value={formData.skin}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            variant="outlined"
                            required
                            fullWidth
                            label="Hair (Lice)"
                            name="hair"
                            value={formData.hair}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Limiting Conditions"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            multiline
                            rows={4}
                            name="limitingConditions"
                            value={formData.limitingConditions}
                            onChange={handleChange}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Additional Findings or Comments"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            multiline
                            rows={8}
                            name="additionalFindings"
                            value={formData.additionalFindings}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
  <Typography variant="h6" align="start">Upload Physician Attestation</Typography>
  {signatureImageFile && (
    <Avatar src={URL.createObjectURL(signatureImageFile)} variant="square" sx={{ width: 100, height: 100, mb: 2 }} />
  )}
  <Button
    variant="contained"
    component="label"
    startIcon={<PhotoCamera />}
    disabled={!!signatureImageFile}
  >
    {signatureImageFile ? 'Uploaded' : 'Upload Physician Attestation'}
    <input type="file" hidden onChange={handleSignatureFileChange} />
  </Button>
</Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Button type="submit" variant="contained" color="primary">
                            Submit
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Container>
    );
};

export default MedicalForm;
